import { SingleNews } from '@toggle/toggle';
import { useEffect, useState } from 'react';

import { useNewsWatchlistsStore } from '~/stores/use-news-watchlists/useNewsWatchlistsStore';
import { useNews } from '~/views/dashboard/hooks/use-news/useNews';
import { getUniqueTags } from '~/views/news/utils/get-unique-tags/getUniqueTags';
import {
  formatCurrentTimeHoursMinutes,
  TabsType,
} from '~/views/news/utils/utils';

export const useNewsStatesDashboard = (activeTab: TabsType) => {
  const [refetchTimestamp, setRefetchTimestamp] = useState(new Date());
  const [prevRefetchTimestamp, setPrevRefetchTimestamp] =
    useState(refetchTimestamp);
  const [activeNewsList, setActiveNewsList] = useState<SingleNews[]>([]);

  const formattedRefetchTime = formatCurrentTimeHoursMinutes(refetchTimestamp);

  const { watchlistsToCheck } = useNewsWatchlistsStore();
  const uniqueTags = getUniqueTags(watchlistsToCheck);
  const {
    data: newsData,
    isRefetching,
    refetch,
    isLoading,
  } = useNews(activeTab, uniqueTags);

  const handleRefetch = () => {
    refetch();
  };

  useEffect(() => {
    if (newsData?.news) {
      setActiveNewsList(newsData?.news);
    }
  }, [isRefetching, newsData]);

  useEffect(() => {
    if (isRefetching) {
      setPrevRefetchTimestamp(refetchTimestamp);
      setRefetchTimestamp(new Date());
    }
  }, [isRefetching]);

  return {
    uniqueTags,
    refetchTimestamp,
    prevRefetchTimestamp,
    formattedRefetchTime,
    activeNewsList,
    handleRefetch,
    isRefetching,
    isLoading,
  };
};
